export enum IEvent {
  CONNECT = 'connect',
  DISCONNECT = 'disconnect'
}
